// 正式
module.exports = {
  title: '万里长城',
  baseUrl: '', // 正式项目地址
  baseApi: '/api/', // 正式api请求地址
  APPID: '',
  APPSECRET: '',
  $cdn: ''
}